export const getReferralAnalysesData = state => state.referralAnalyses.all;
export const getReferralAnalysisData = state => state.referralAnalyses.referralAnalysis;
export const referralAnalysesIsFetching = state => state.referralAnalyses.loading.all;
export const referralAnalysisIsFetching = state => state.referralAnalyses.loading.referralAnalysis;
